.alert {
  display: flex;
  align-items: flex-start;
  gap: var(--hs-spacing-3);
  padding: var(--hs-spacing-3) var(--hs-spacing-4);
  border-radius: var(--hs-radius-md);
  font: var(--hs-type-body-s);
}
.icon {
  flex: none;
  margin-top: 1px;
}
.text {
  display: flex;
  flex-direction: column;
  gap: var(--hs-spacing-1);
  min-width: 0;
}
.title {
  margin: 0;
  font: var(--hs-type-label);
  letter-spacing: var(--hs-label-ls);
}
.info {
  background: var(--hs-color-primary-container);
  color: var(--hs-color-primary-deep);
}
.success {
  background: var(--hs-color-secondary-container-soft);
  color: var(--hs-color-secondary-deep);
}
.danger {
  background: var(--hs-color-danger-container);
  color: var(--hs-color-danger-on-container);
}
.warning {
  background: var(--hs-color-warning-container);
  color: var(--hs-color-warning-on-container);
}
